const sizeRefEl = document.querySelector('#mainVP');
const refSize = {
    w: 1368,
    h: 769
};

module.exports = (el, ratio = 0.5) => {
    return {
        el: el,
        resize: () => {
            const rect = sizeRefEl.getBoundingClientRect();
            const winW = rect.width;
            const winH = rect.height;
            const scaleH = winH / refSize.h;
            const scaleW = winW / refSize.w;
            const scale = Math.max(scaleH, scaleW);

            const w1 = scale * refSize.w;
            const h1 = scale * refSize.h;

            el.style.width = w1 + 'px';
            el.style.height = h1 + 'px';
            el.style.transform = `translate3d(${-Math.min(Math.max(w1 * ratio - winW * 0.5, 0), w1 - winW)}px, 0, 0)`;
        }
    };
};
